import { Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';

import { Typography } from '@speeki/global-ui-components';

import { ContainerSection } from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import {
    ReportMessagesBox,
    ReportWrapper,
    StyledContainerInner,
    StyledContainerSection,
} from './MyReportPage.styled';
import {
    Message,
    ReportUploadFiles,
    SkeletonBoxTitle,
    SkeletonFileWrapper,
} from './SkeletonMyReportPage.styled';

const SkeletonMyReportPage = () => {
    const skeletonText = (uniqueKey: string) => (
        <>
            {[...Array(5).keys()].map((_, index) => (
                <SkeletonFileWrapper key={`${uniqueKey}_${index}`}>
                    <Skeleton height={16} width={`100%`} />
                </SkeletonFileWrapper>
            ))}
        </>
    );

    return (
        <DefaultLayout headerProps={{ withLoginActions: true }}>
            <Container>
                <StyledContainerInner>
                    <ContainerSection>
                        <Typography.TextH3_24_34>
                            <Skeleton height={24} width={150} />
                        </Typography.TextH3_24_34>
                    </ContainerSection>
                    <StyledContainerSection>
                        <Skeleton height={24} width={150} />
                    </StyledContainerSection>
                </StyledContainerInner>

                <ReportWrapper>
                    <ReportMessagesBox>
                        <SkeletonBoxTitle>
                            <Skeleton height={20} width={300} />
                        </SkeletonBoxTitle>
                        {Array(5)
                            .fill(0)
                            .map((_, index) => (
                                <Fragment key={index}>
                                    <Message>
                                        <Skeleton height={16} width={`80%`} />
                                    </Message>
                                    <Message>
                                        <Skeleton height={16} width={`100%`} />
                                    </Message>
                                </Fragment>
                            ))}
                    </ReportMessagesBox>
                    <ReportUploadFiles>
                        <SkeletonBoxTitle>
                            <Skeleton height={20} width={300} />
                        </SkeletonBoxTitle>
                        {skeletonText('uploadFiles')}
                    </ReportUploadFiles>
                </ReportWrapper>
            </Container>
        </DefaultLayout>
    );
};

export default SkeletonMyReportPage;
